module.exports = __webpack_public_path__ + "media/images/ic_analytics-36fb9c627578db9b8b6c6765eb794a62.svg";